import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ArchiveFile } from '../models/archive/archive-file.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ArchiveFileService extends RequestService<ArchiveFile> {
  static PATH = '/archive/file';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, ArchiveFileService.PATH, globalService.debugUrl);
  }

  listFormInfoByCatalogId(catalogId: number) {
    return this.httpClient.get<
      {
        code: string;
        name: string;
      }[]
    >(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveFileService.PATH}/listFormInfoByCatalogId/${catalogId}`,
    );
  }

  listMaterialSelfCheckReportFileInfo(id: number) {
    return this.httpClient.get<
      {
        fileId: string;
      }[]
    >(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveFileService.PATH}/listMaterialSelfCheckReportFileInfo/${id}`,
    );
  }

  listMaterialSpotCheckReportFileInfo(id: number) {
    return this.httpClient.get<
      {
        fileId: string;
      }[]
    >(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveFileService.PATH}/listMaterialSpotCheckReportFileInfo/${id}`,
    );
  }

  listStandardTestSpotCheckReportFileInfo(arg0: number) {
    throw new Error('Method not implemented.');
  }
  listStandardTestSelfCheckReportFileInfo(arg0: number) {
    throw new Error('Method not implemented.');
  }
}
